import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import mobilingo from './assets/mobilingo.png'
import imtahan from './assets/imtahan.png'
import tats from './assets/tats.png'
import aston from './assets/aston.png'
import ellas from './assets/ellas.png'
import cash from './assets/cashlook.png'

gsap.registerPlugin(ScrollTrigger);

const IMAGES = [
  imtahan,
aston,
cash,
tats,
ellas,

  mobilingo,
  
];

const Projects = () => {
  const { t } = useLang();
  const sectionRef = useRef(null);
  const trackRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Horizontal scroll pinning (desktop only)
      const mm = gsap.matchMedia();
      mm.add("(min-width: 1024px)", () => {
        const track = trackRef.current;
        if (!track) return;
        const scrollLength = track.scrollWidth - window.innerWidth + 120;
        gsap.to(track, {
          x: -scrollLength,
          ease: "none",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top top",
            end: () => `+=${scrollLength}`,
            scrub: 0.6,
            pin: true,
            anticipatePin: 1,
            invalidateOnRefresh: true,
          },
        });
      });

    }, sectionRef);
    return () => ctx.revert();
  }, [t]);

  return (
    <section
      id="projects"
      ref={sectionRef}
      data-testid="projects-section"
      className="relative py-24 md:py-32 lg:py-0 lg:min-h-screen overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:pt-24">
        <div className="proj-head max-w-3xl">
          <div className="text-[11px] tracking-[0.3em] uppercase font-bold text-[#00F0FF] mb-4">
            {t.projects.overline}
          </div>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl tracking-tight gradient-text" data-testid="projects-title">
            {t.projects.title}
          </h2>
          <p className="mt-5 text-[#9BA1B0] text-base sm:text-lg font-body">
            {t.projects.subtitle}
          </p>
        </div>
      </div>

      {/* Horizontal track on desktop, vertical on mobile */}
      <div className="mt-12 lg:mt-16 overflow-hidden">
        <div
          ref={trackRef}
          className="flex flex-col lg:flex-row gap-6 lg:gap-8 px-6 md:px-12 pb-6 lg:pb-0 lg:w-max"
        >
          {t.projects.items.map((p, i) => (
            <article
              key={i}
              data-testid={`project-card-${i}`}
              className="glass rounded-3xl overflow-hidden lg:w-[460px] xl:w-[520px] shrink-0 group hover:border-[#00F0FF]/35 transition-all duration-500"
            >
              <div className="relative h-56 md:h-64 overflow-hidden">
                <img
                  src={IMAGES[i % IMAGES.length]}
                  alt={p.name}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#030407] via-[#030407]/40 to-transparent" />
                <div className="absolute top-4 left-4 text-[10px] tracking-[0.25em] uppercase font-bold text-[#00F0FF] glass px-3 py-1 rounded-full">
                  0{i + 1}
                </div>
              </div>
              <div className="p-7 md:p-8">
                <h3 className="font-heading font-bold text-2xl md:text-3xl text-white">{p.name}</h3>
                {/* <p className="mt-3 text-sm md:text-base text-[#9BA1B0] font-body leading-relaxed">{p.desc}</p> */}
                {/* <div className="mt-5 flex flex-wrap gap-2">
                  {p.tech.map((t2) => (
                    <span key={t2} className="tech-chip">{t2}</span>
                  ))}
                </div> */}
                <button
                  data-testid={`project-view-${i}`}
                  onClick={() => window.open(p.link, "_blank")}
                  className="mt-7 inline-flex items-center gap-2 text-sm font-heading font-semibold text-[#00F0FF] hover:gap-3 transition-all"
                >
                  {t.projects.viewProject}
                  <ArrowUpRight size={16} strokeWidth={2} />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
